export const WORK_API_URL =
  process.env.REACT_APP_WORK_API_URL || "https://work.4-handy.com";
